// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"43bf5f330e321e8a","6564":"61089f14bc4bf9a4"}[chunkId] + ".css";
};